import { useEffect, useRef, useState } from 'react';

import BrowserInteractionTime from 'browser-interaction-time';

export const useBrowserInteractionTime = (
	threshold: number,
): {
	active: boolean;
	tabActive: boolean;
} => {
	const [active, setActive] = useState<boolean>(true);
	const [tabActive, setTabActive] = useState<boolean>(true);
	const activeRef = useRef(active);

	activeRef.current = active;

	useEffect(() => {
		let timer: BrowserInteractionTime | null;
		timer = new BrowserInteractionTime({
			idleTimeoutMs: threshold,
			stopTimerOnTabchange: false,
			browserTabActiveCallbacks: [
				() => {
					setTabActive(true);
				},
			],
			browserTabInactiveCallbacks: [
				() => {
					setTabActive(false);
				},
			],
			idleCallbacks: [
				() => {
					if (activeRef.current) {
						setActive(false);
					}
				},
			],
			activeCallbacks: [
				() => {
					if (!activeRef.current) {
						setActive(true);
					}
				},
			],
		});
		timer.startTimer();

		return () => {
			timer && timer.destroy();
			timer = null;
		};
	}, [threshold]);

	return { active, tabActive };
};
